export const MIN_QUANTITY = 1
export const MAX_QUANTITY_MG = 500_000

// Log-scaled step thresholds for trade quantity inputs. The step size
// grows with the quantity so that a single slider can usefully cover
// the full 1 mg ↔ 500,000 mg range without being unusable at either
// end. Each tuple is [exclusiveUpperBound, stepSizeInsideBucket].
// Thresholds align with gram-scale display: steps grow at 1g, 10g, 100g,
// then 10g steps beyond 50% of max (250g).
const STEPS: ReadonlyArray<readonly [number, number]> = [
  [1_000, 1],
  [10_000, 10],
  [100_000, 100],
  [MAX_QUANTITY_MG / 2, 1_000],
  [Number.POSITIVE_INFINITY, 10_000]
] as const

export const stepFor = (quantity: number): number => {
  for (const [bound, step] of STEPS) {
    if (quantity < bound) return step
  }
  return STEPS[STEPS.length - 1][1]
}

export const incrementQuantity = (quantity: number, max: number): number =>
  Math.min(quantity + stepFor(quantity), max)

export const decrementQuantity = (quantity: number, min: number): number => {
  const next = quantity - stepFor(Math.max(quantity - 1, min))
  return Math.max(next, min)
}
